export const DURATION = 6000
